import React from 'react'
import PropTypes from 'prop-types'

// imports
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import { Box, Select, Typography } from '@the-platform-group/component-library'
import { Grid } from '@the-platform-group/component-library/Layout'

// hooks
import useReviews from './hooks/useReviews'
import { useSessionState } from 'contexts/Session'
import { getColumnValues, getRowValues } from './ReviewTableValues'
import { handleSortModelChange } from 'components/Table/utils'

const ReviewListComponent = () => {
  const {
    filterState,
    reviews,
    customerOptions,
    isLoading,
    setCustomerFilter,
    page,
    rowsPerPage,
    rowCount,
    setPage,
    setRowsPerPage,
    handleOnSort,
  } = useReviews()
  const { currentUser } = useSessionState()

  return (
    <>
      <Typography variant="h4" component="h1">
        NOBO Reviews
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={9} />
        <Grid item xs={3}>
          <Select
            allowEmpty
            fullWidth
            id="customer_id"
            name="customer_id"
            placeholder="Filter by Customer..."
            options={customerOptions}
            value={filterState.customerId}
            onChange={e => setCustomerFilter(e.target)}
          />
        </Grid>
      </Grid>
      <Box sx={{ flexGrow: 1 }}>
        <DataGrid
          columns={getColumnValues(customerOptions)}
          commonColumnProps={{ align: 'center', headerAlign: 'center' }}
          rows={getRowValues(reviews, currentUser)}
          onSortModelChange={sortModel => handleSortModelChange(sortModel, handleOnSort, true)}
          initialState={{
            sorting: {
              sortModel: [{ field: 'created_at', sort: 'asc' }],
            },
          }}
          loading={isLoading}
          name="noboReviews"
          paginationMode="server"
          page={page}
          pageSize={rowsPerPage}
          rowCount={rowCount}
          pageSizeOptions={[25, 50, 100]}
          onPageChange={newPage => setPage(newPage)}
          onPageSizeChange={newPageSize => setRowsPerPage(newPageSize)}
        />
      </Box>
    </>
  )
}

ReviewListComponent.propTypes = {
  history: PropTypes.object.isRequired,
}

export default ReviewListComponent
